/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState } from 'react';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import RadioGroupComponent from '../RadioGroup/RadioGroupBtn';

import DisplayErrorMessages from '../Errors/ErrorMessages';

import SVGComponent from '../SVGComponents/SVGComponents';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../AgGridUtilities/suppressNavigation';
// eslint-disable-next-line camelcase
import { viewPortHeight_355 } from '../CommonConstants/commonConstants';
import {
  NDC_CODE_FOR_STC_NOT,
  NDC_ALREADY_FOR_STC_NOT,
  ERRORMESSAGE_NDC_NOT_EMPTY,
  NO_DATA_TO_DISPLAY,
  NDC_NOT_FOUND_STC,
  NDC_ATLEAST_SELECT_ONE,
  NOT_SELECTED_ANY_MFG,
} from '../Errors/constantMessageData';
import TableGridWithFeatures from '../Table/TableGridWithFeatures';
import {
  getLabelerList,
  searchNDCByIDORDrugName,
  getNDCByLabeller,
} from './store/actions';
import { labelerTableHead, NDCTableHead, searchTypeVals } from './TableHead';
import { handleScrollToEvent } from '../CommonUtilities/commonUtilities';

const SearchTypeComponent = (props) => {
  const gridRefLeft = React.useRef();
  const gridRefRight = React.useRef();
  const [selectedVal, setSelectedVal] = useState('NDC');
  const [searchValue, setSearchValue] = useState('');
  const [ndcVal, setNdcVal] = useState('');
  const [labellerData, setLabellerData] = useState([]);
  const [ndcLeftData, setNDCLeftData] = useState([]);
  const [ndcRightData, setNDCRightData] = useState([]);
  const [ndcLeftRowSelected, setNdcLeftRowSelected] = useState(
    // eslint-disable-next-line react/destructuring-assignment
    props.ndcLeftSelectedRows ? props.ndcLeftSelectedRows : []
  );
  const [ndcRightRowSelected, setNdcRightRowSelected] = useState(
    // eslint-disable-next-line react/destructuring-assignment
    props.ndcRightSelectedRows ? props.ndcRightSelectedRows : []
  );
    const firstInfo=props.firstInfo;

  // eslint-disable-next-line no-unused-vars
  const [fullScreenView, setFullScreenView] = useState(false);
  const [labelerSelected, setLabelerSelected] = useState(
    // eslint-disable-next-line react/destructuring-assignment
    props.labelerSelectedRow ? props.labelerSelectedRow : {}
  );
  const [loading, setLoading] = useState(false);
  const [leftGridAPI, setLeftGridAPI] = useState();
  const [errorMessages, setErrorMessages] = useState([]);
  const [flag, setFlag] = useState(false);
  React.useEffect(() => {
    if (props.searchType) {
      if (
        // eslint-disable-next-line eqeqeq
        props.searchType == 'Labeler' &&
        !props?.labelerTableData?.length > 0
      ) {
        handleSearchByClick(props.searchType);
      }
      setSelectedVal(props.searchType);
    }
    if (props.errorMsgFromSearchType) {
      setErrorMessages(props.errorMsgFromSearchType);
    }
    if (props.ndcLeftSelectedRows) {
      setNdcLeftRowSelected(props.ndcLeftSelectedRows);
    }
    if (props.ndcRightSelectedRows) {
      setNdcRightRowSelected(props.ndcRightSelectedRows);
    }
    if (props.labelerSelectedRow) {
      setLabelerSelected(labelerSelected);
    }

    if (props.labelerTableData) {
      setLabellerData(props.labelerTableData);
    }
    if (props.ndcLeftTableData) {
      setNDCLeftData(props.ndcLeftTableData);
    }
    if (props.ndcRightTableData) {
      setNDCRightData(props.ndcRightTableData);
    }
    if (props.ndcSearchVal) {
      setNdcVal(props.ndcSearchVal);
    }
    if (props.ndcNameSearchVal) {
      setSearchValue(props.ndcNameSearchVal);
    }
  }, []);

  React.useEffect(() => {
    props.setNdcSearchVal(ndcVal);
  }, [ndcVal]);

  React.useEffect(() => {
    props.setNdcNameSearchVal(searchValue);
  }, [searchValue]);

  React.useEffect(() => {
    if (props.getErrorsFromSearchTypeComponent) {
      props.getErrorsFromSearchTypeComponent(errorMessages);
    }
  }, [errorMessages]);

  React.useEffect(() => {
    props.setNdcLeftSelectedRows(ndcLeftRowSelected);
  }, [ndcLeftRowSelected]);

  React.useEffect(() => {
    props.setNdcRightSelectedRows(ndcRightRowSelected);
  }, [ndcRightRowSelected]);
  React.useEffect(() => {
    props.setlabelerSelectedRow(labelerSelected);
  }, [labelerSelected]);

  React.useEffect(() => {
    props.setlabelerTableData(labellerData);
  }, [labellerData]);

  React.useEffect(() => {
    props.setNdcLeftTableData(ndcLeftData);
  }, [ndcLeftData]);

  React.useEffect(() => {
    props.setNdcRightTableData(ndcRightData);
  }, [ndcRightData]);

  const labelerRowSelected = async (rowDet) => {
    if (rowDet) {
      setLoading(true);
      // handleClearFilterLeft();
      const ndcList = await getNDCByLabeller({
        labelerCode: rowDet,
      });
      if (ndcList) {
        if (ndcList.message === 'SUCESS') {
          if (ndcList.data.length > 0) {
            const arrayOfNDCFromLabeler = [];
            const arrayOfNDCLabForComm = [];
            // eslint-disable-next-line array-callback-return
            ndcList.data.map((element) => {
              const obj = {};
              obj.ndc = `${element?.labelerCode}-${element?.productCode}-${element?.packageSize}`;
              obj.drugName = element?.drugName;
              obj.fromExisting = 1;
              arrayOfNDCFromLabeler.push(obj);
              const objForComm = {
                ...element,
                ndc: `${element?.labelerCode}-${element.productCode}-${element.packageSize}`,
              };
              arrayOfNDCLabForComm.push(objForComm);
            });

            setNDCLeftData(arrayOfNDCLabForComm);
          }
        }
      }

      setLoading(false);
    }
  };
  const handleSearchByClick = async (value) => {
    // eslint-disable-next-line eqeqeq
    if (value && value != selectedVal) {
      // eslint-disable-next-line vars-on-top, no-var
      var errorMess = errorMessages;
      // eslint-disable-next-line eqeqeq
      errorMess = errorMess.filter((item) => item.field != 'searchByNameError');
      // eslint-disable-next-line eqeqeq
      errorMess = errorMess.filter((item) => item.field != 'ndcTextBox');
      errorMess = errorMess.filter(
        // eslint-disable-next-line eqeqeq
        (item) => item.field != 'resultNotFoundNDCText'
      );

      // eslint-disable-next-line vars-on-top, no-var, block-scoped-var
      var arrayOfLabelerList = [];
      setNDCLeftData([]);
      setSearchValue('');
      setNdcVal('');
      setNdcLeftRowSelected([]);
      setLabelerSelected('');
      setSelectedVal(value);
      if (props.setSearchType) {
        props.setSearchType(value);
      }
      // eslint-disable-next-line eqeqeq
      if (value == 'Labeler') {
        setLoading(true);
        // eslint-disable-next-line no-shadow
        const labellerData = await getLabelerList();

        if (labellerData?.data) {
          if (labellerData?.data?.message === 'SUCESS') {
            if (labellerData?.data?.data?.length > 0) {
              // eslint-disable-next-line vars-on-top, no-var, no-redeclare
              var arrayOfLabelerList = [];
              errorMess = errorMess.filter(
                // eslint-disable-next-line eqeqeq
                (item) => item.field != 'searchByNameError'
              );
              // eslint-disable-next-line array-callback-return
              labellerData.data.data.map((element) => {
                const obj = {};
                obj.labelerCode = element.labelerCode;
                obj.labelerName = element.labelerName;
                arrayOfLabelerList.push(obj);
              });
              setLabellerData(arrayOfLabelerList);
              setLoading(false);
            } else {
              setLoading(false);
              errorMess = errorMess.filter(
                // eslint-disable-next-line eqeqeq
                (item) => item.errorType != 'noDataFromLabeler'
              );
              errorMess.push({
                field: 'searchByNameError',
                errorType: 'noDataFromLabeler',
                errorComponent: 'searchTypeComponent',
                message: NO_DATA_TO_DISPLAY,
              });
            }
          }
        }
      }
    }
    if (errorMess?.length > 0) {
      handleScrollToEvent();
    }
    // eslint-disable-next-line block-scoped-var
    setErrorMessages(errorMess);
    setLoading(false);
  };
  const handleFullScreenLabeler = () => {
    props.setLabelerFullScreen(!props.labelerFullScreen);
  };

  const handleFullScreenNdcLeft = () => {
    props.setNdcLeftFullScreen(!props.ndcLeftFullScreen);
  };

  const handleFullScreenNdcRight = () => {
    props.setNdcRightFullScreen(!props.ndcRightFullScreen);
  };

  const handleBlur = (fType, e, empty = false) => {
    let errorMessageForNDC = empty ? [] : errorMessages;

    if (e.target.value) {
      const seVal = e.target.value;
      const regexP = /^[\^A-Za-z0-9]{5}-[\^A-Za-z0-9]{4}-[\^A-Za-z0-9]{2}$/;

      // eslint-disable-next-line eqeqeq
      if (seVal.length != 13 || !regexP.test(seVal)) {
        errorMessageForNDC = errorMessageForNDC.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.field != 'ndcTextBox'
        );
        errorMessageForNDC = errorMessageForNDC.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.field != 'resultNotFoundNDCText'
        );
        errorMessageForNDC = errorMessageForNDC.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.field != 'searchByNameError'
        );
        errorMessageForNDC.push({
          field: 'ndcTextBox',
          errorType: 'ndcFormat',
          errorComponent: 'searchTypeComponent',
          message: NDC_CODE_FOR_STC_NOT,
        });
      } else {
        errorMessageForNDC = errorMessageForNDC.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.field != 'ndcTextBox'
        );
      }
    } else {
      errorMessageForNDC = errorMessageForNDC.filter(
        // eslint-disable-next-line eqeqeq
        (item) => item.field != 'ndcTextBox'
      );
      errorMessageForNDC = errorMessageForNDC.filter(
        // eslint-disable-next-line eqeqeq
        (item) => item.field != 'resultNotFoundNDCText'
      );
    }
    setErrorMessages(errorMessageForNDC);
    return errorMessageForNDC;
  };

  const onSearchByNDCs = (fType, e) => {
    if (
      (e.target.value &&
        // eslint-disable-next-line eqeqeq
        e.target.value.length == 5 &&
        !flag &&
        // eslint-disable-next-line eqeqeq
        !(e.keyCode == 8)) ||
      (e.target.value &&
        // eslint-disable-next-line eqeqeq
        e.target.value.length == 10 &&
        !flag &&
        // eslint-disable-next-line eqeqeq
        !(e.keyCode == 8))
    ) {
      setNdcVal(`${e.target.value}-`);
      // eslint-disable-next-line eqeqeq
    } else if (e.keyCode == 8) {
      setFlag(true);
      setNdcVal(e.target.value);
    } else {
      setFlag(false);
      setNdcVal(e.target.value);
    }
    if (e.key === 'Enter') {
      const err = handleBlur('', e, true);
      if (!err.length) actionNDCsMove('leftToRight', 'ndcLeftData', true);
      return;
    }
  };

  const onGridReadyLabeler = (params) => {
    if (!labelerSelected?.labelerCode) {
      params.api.forEachNode(
        // eslint-disable-next-line eqeqeq
        (node) => node?.rowIndex == 0 && node?.setSelected(true)
      );

      setLoading(true);

      const selectedRowNodes = params.api.getSelectedNodes();
      onRowSelect('labeler', selectedRowNodes[0]?.data);
    } else {
      params.api.forEachNode(
        (node) =>
          // eslint-disable-next-line eqeqeq
          node?.data?.labelerCode == labelerSelected.labelerCode &&
          node?.setSelected(true)
      );
    }
  };

  const handleClearFilterLeft = () => {
    if (ndcLeftData && ndcLeftData.length > 0 && gridRefLeft?.current) {
      gridRefLeft.current.clearFilters();
    }
  };

  const handleClearFilterRight = () => {
    if (ndcRightData && ndcRightData.length > 0 && gridRefRight?.current) {
      gridRefRight.current.clearFilters();
    }
  };

  const onGridReadyLeftNDC = (params, deselect) => {
    if (!deselect) {
      setLeftGridAPI(params);
      if (ndcLeftRowSelected?.length > 0) {
        ndcLeftRowSelected.forEach((elem) => {
          if (elem?.ndc) {
            params.api.forEachNode(
              // eslint-disable-next-line eqeqeq
              (node) => node?.data?.ndc == elem.ndc && node?.setSelected(true)
            );
          }
        });
      }
    } else {
      // eslint-disable-next-line no-unused-expressions
      params?.api?.deselectAll();
      setLeftGridAPI(params);
    }
  };
  const onGridReadyRightNDC = (params) => {
    if (ndcRightRowSelected?.length > 0) {
      ndcRightRowSelected.forEach((elem) => {
        if (elem?.ndc) {
          params.api.forEachNode(
            // eslint-disable-next-line eqeqeq
            (node) => node?.data?.ndc == elem.ndc && node?.setSelected(true)
          );
        }
      });
    }
  };
  const onSelectionChangedLeft = (params) => {
    const selectedRowNodes = params.api.getSelectedNodes();

    const array = [];
    selectedRowNodes.forEach((elem) => {
      array.push(elem.data);
    });
    setNdcLeftRowSelected(array);
  };

  const onSelectionChangedRight = (params) => {
    const selectedRowNodes = params.api.getSelectedNodes();
    const array = [];
    selectedRowNodes.forEach((elem) => {
      array.push(elem.data);
    });
    setNdcRightRowSelected(array);
  };

  const onRowSelect = (field, row) => {
    if (field == 'labeler') {
      setLabelerSelected(row);
      labelerRowSelected(row?.labelerCode);
    }
  };

  const handleSearchName = async (fType) => {
    let errorMessageSearch = errorMessages;
    if (fType === 'onClick') {
      // handleClearFilterLeft();
      setLoading(true);
      let searchResult = '';
      if (searchValue) {
        searchResult = await searchNDCByIDORDrugName({
          searchBy: 'drugName',
          inputValue: searchValue,
          page: 0,
          pageSize: 1000000000,
        });
      }

      if (searchValue.trim().length === 0) {
        errorMessageSearch.push({
          field: 'searchByNameError',
          errorType: 'searchNameNoResult',
          errorComponent: 'searchTypeComponent',
          message: 'Please Enter a valid search value.',
        });
      } else {
        if (!searchResult) {
          setLoading(false);
          setNDCLeftData([]);
          errorMessageSearch = errorMessageSearch.filter(
            (item) => item.field != 'searchByNameError'
          );
          errorMessageSearch.push({
            field: 'searchByNameError',
            errorType: 'searchNameNoResult',
            errorComponent: 'searchTypeComponent',
            message: NDC_NOT_FOUND_STC,
          });
        } else {
          const ndcArraySearched = [];
          setLoading(false);
          if (searchResult.data.message === 'SUCESS') {
            if (searchResult.data.data.length > 0) {
              errorMessageSearch = errorMessageSearch.filter(
                (item) => item.field != 'searchByNameError'
              );

              searchResult.data.data.map((item) => {
                const obj = {
                  ...item,
                  ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
                };
                ndcArraySearched.push(obj);
              });
            } else {
              errorMessageSearch = errorMessageSearch.filter(
                (item) => item.field != 'searchByNameError'
              );
              errorMessageSearch.push({
                field: 'searchByNameError',
                errorType: 'searchNameNoResult',
                errorComponent: 'searchTypeComponent',
                message: NDC_NOT_FOUND_STC,
              });
              setLoading(false);
            }
            setNDCLeftData(ndcArraySearched);
          }
        }
      }
    }

    setErrorMessages(errorMessageSearch);
  };

  const handleChangeSearchVal = (value) => {
    setSearchValue(value);
  };

  const actionNDCsMove = async (moveFrom, rows, empty = false) => {
    let errorHandleInMove = empty ? [] : errorMessages;

    let leftList = [];
    let rightList = [];
    if (ndcVal && moveFrom === 'leftToRight') {
      setLoading(true);
      // handleBlur('onBlur', ndcVal);
      const ndcResult = await searchNDCByIDORDrugName({
        searchBy: 'ndc',
        inputValue: ndcVal,
        page: 1,
        pageSize: 1,
      });
      errorHandleInMove = errorHandleInMove.filter(
        (item) => item.field != 'searchByNameError'
      );
      if (!ndcResult) {
        const errMsg = errorHandleInMove.filter(
          (item) => item.message === NDC_CODE_FOR_STC_NOT
        );
        if (!(errMsg.length > 0)) {
          errorHandleInMove = errorHandleInMove.filter(
            (item) => item.field != 'resultNotFoundNDCText'
          );
          errorHandleInMove.push({
            field: 'resultNotFoundNDCText',
            errorType: 'searchByNDC',
            errorComponent: 'searchTypeComponent',
            message: NDC_NOT_FOUND_STC,
          });
        }
        setLoading(false);
        rightList = ndcRightData || [];
        setNDCLeftData([]);
      } else {
        const ndcArraySearched = [];
        setLoading(false);
        if (ndcResult.data.message === 'SUCESS') {
          if (ndcResult.data.data.length > 0) {
            errorHandleInMove = errorHandleInMove.filter(
              (item) => item.field != 'resultNotFound'
            );

            errorHandleInMove = errorHandleInMove.filter(
              (item) => item.field != 'resultNotFoundNDCText'
            );

            ndcResult.data.data.map((item) => {
              const obj = {
                ...item,
                ndc: `${item.labelerCode}-${item.productCode}-${item.packageSize}`,
              };
              ndcArraySearched.push(obj);
            });
          } else {
            errorHandleInMove = errorHandleInMove.filter(
              (item) => item.field != 'resultNotFoundNDCText'
            );
            errorHandleInMove.push({
              field: 'resultNotFoundNDCText',
              errorType: 'searchByNDC',
              errorComponent: 'searchTypeComponent',
              message: NDC_NOT_FOUND_STC,
            });
            setLoading(false);
          }

          var found = false;

          ndcRightData?.length > 0 &&
            ndcRightData.forEach((element) => {
              if (ndcArraySearched?.length > 0) {
                if (
                  ndcArraySearched.filter((el) => el.ndc == element.ndc)
                    ?.length > 0
                ) {
                  found = true;
                }
              }
            });

          if (!found) {
            rightList = ndcRightData.concat(ndcArraySearched);
            errorHandleInMove = errorHandleInMove.filter(
              (item) => item.field != 'searchByNameError'
            );
            setNdcLeftRowSelected([]);
            onGridReadyLeftNDC(leftGridAPI, true);
          } else {
            errorHandleInMove = errorHandleInMove.filter(
              (item) => item.field != 'searchByNameError'
            );
            errorHandleInMove.push({
              field: 'searchByNameError',
              errorType: 'alreadypresentNDCInRight',
              errorComponent: 'searchTypeComponent',
              message: NDC_ALREADY_FOR_STC_NOT,
            });
            rightList = ndcRightData;
          }

          ndcLeftRowSelected.push({ data: ndcArraySearched });
        }
      }
    }
    if (moveFrom === 'AllLeftToRight') {
      setNdcLeftRowSelected([]);
      setNdcRightRowSelected([]);
      if (!_.isEmpty(ndcLeftData)) {
        leftList = [];

        var found = false;

        var arrayAlready = [];
        var differentNDC = [];

        ndcRightData?.length > 0 &&
          ndcRightData.forEach((element) => {
            if (ndcLeftData?.length > 0) {
              if (
                ndcLeftData.filter((el) => el.ndc == element.ndc)?.length > 0
              ) {
                arrayAlready.push(element);
              } else {
                differentNDC.push(element);
              }
            }
          });

        if (arrayAlready?.length > 0) {
          rightList = ndcLeftData;
        } else {
          rightList = ndcLeftData;
        }

        rightList = [...differentNDC, ...rightList];
        // rightList = ndcRightData.concat(ndcLeftData);
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        setNdcLeftRowSelected([]);
        onGridReadyLeftNDC(leftGridAPI, true);
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        errorHandleInMove.push({
          field: 'searchByNameError',
          errorType: 'NDCnotSelected',
          errorComponent: 'searchTypeComponent',
          message: NDC_ATLEAST_SELECT_ONE,
        });
        leftList = ndcLeftData;
        rightList = ndcRightData;
      }
    }
    if (moveFrom === 'AllRightToLeft') {
      setNdcRightRowSelected([]);
      if (!_.isEmpty(ndcRightData)) {
        rightList = [];
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        errorHandleInMove.push({
          field: 'searchByNameError',
          errorType: 'NDCnotSelected',
          errorComponent: 'searchTypeComponent',
          message: NDC_ATLEAST_SELECT_ONE,
        });
        leftList = ndcLeftData;
        rightList = ndcRightData;
      }
    }
    if (moveFrom === 'leftToRight' && !ndcVal) {
      if (!_.isEmpty(ndcLeftData) && ndcLeftRowSelected.length > 0) {
        const listLeft = ndcLeftRowSelected;

        var found = false;

        ndcRightData?.length > 0 &&
          ndcRightData.forEach((element) => {
            if (listLeft?.length > 0) {
              if (listLeft.filter((el) => el.ndc == element.ndc)?.length > 0) {
                found = true;
              }
            }
          });

        if (!found) {
          rightList = ndcRightData.concat(listLeft);
          errorHandleInMove = errorHandleInMove.filter(
            (item) => item.field != 'searchByNameError'
          );
          setNdcLeftRowSelected([]);
          onGridReadyLeftNDC(leftGridAPI, true);
        } else {
          errorHandleInMove = errorHandleInMove.filter(
            (item) => item.field != 'searchByNameError'
          );
          errorHandleInMove.push({
            field: 'searchByNameError',
            errorType: 'alreadypresentNDCInRight',
            errorComponent: 'searchTypeComponent',
            message: NDC_ALREADY_FOR_STC_NOT,
          });
          rightList = ndcRightData;
        }
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        errorHandleInMove.push({
          field: 'searchByNameError',
          errorType: 'NDCnotSelected',
          errorComponent: 'searchTypeComponent',
          message: NDC_ATLEAST_SELECT_ONE,
        });
        leftList = ndcLeftData;
        rightList = ndcRightData;
      }
    }
    if (moveFrom === 'rightToLeft') {
      if (!_.isEmpty(ndcRightData) && ndcRightRowSelected.length > 0) {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        rightList = ndcRightData.filter(
          (ar) => !ndcRightRowSelected.find((rm) => rm.ndc === ar.ndc)
        );
        setNdcLeftRowSelected([]);
        setNdcRightRowSelected([]);
      } else {
        errorHandleInMove = errorHandleInMove.filter(
          (item) => item.field != 'searchByNameError'
        );
        errorHandleInMove.push({
          field: 'searchByNameError',
          errorType: 'NDCnotSelected',
          errorComponent: 'searchTypeComponent',
          message: NDC_ATLEAST_SELECT_ONE,
        });
        leftList = ndcLeftData;
        rightList = ndcRightData;
      }
    }

    setNDCRightData(rightList);
    // handleClearFilterRight();
    setErrorMessages(errorHandleInMove);
    setLoading(false);
  };

  const handleViewButton = async (colName) => {
    let handleErr = errorMessages;
    if (props.id === 'Calculate Interest') {
      handleErr = handleErr.filter((item) => item.field !== 'resultNotFound');
      handleErr = handleErr.filter(
        (item) => item.field !== 'searchByNameError'
      );
      if (colName === 'runNow') {
        props.handleRunNowFunction(ndcRightData);
      } else {
        props.handleRunLaterFunction(ndcRightData);
      }
    } else {
      if (ndcRightData && ndcRightData.length > 0) {
        handleErr = handleErr.filter((item) => item.field != 'resultNotFound');
        handleErr = handleErr.filter(
          (item) => item.field != 'searchByNameError'
        );
        if (props.handleViewDetailFunction) {
          props.handleViewDetailFunction(ndcRightData);
        }
      } else {
        if (props.id === 'reportsNDC') {
          props.handleViewDetailFunction([]);
        }
        handleErr = handleErr.filter((item) => item.field != 'resultNotFound');
        handleErr.push({
          field: 'resultNotFound',
          errorType: 'dataNotSelected',
          errorComponent: 'searchTypeComponent',
          message: ERRORMESSAGE_NDC_NOT_EMPTY,
        });
      }
    }
    if (handleErr?.length > 0) {
      handleScrollToEvent();
    }
    setErrorMessages(handleErr);
  };

  return (
    <div>
      {!(
        props.labelerFullScreen ||
        props.ndcLeftFullScreen ||
        props.ndcRightFullScreen
      ) && (
        <>
          <div className='row'>
            <div
              className={
                props.id === 'Calculate Interest' ||
                props.id === 'Cms-Rosi' ||
                props.id === 'CMS-Drug'
                  ? 'col-12'
                  : 'col-6'
              }
            >
              <RadioGroupComponent
                data-testid='filter-plan-by-radio-btn'
                id='filter-plan-by-radio-btn-action'
                labelName='Search Type'
                required
                optionList={searchTypeVals}
                defaultValue={selectedVal}
                filterAction={(e) => {
                  handleSearchByClick(e);
                }}
              />
            </div>
          </div>

          {selectedVal &&
            selectedVal == 'Labeler' &&
            labellerData &&
            labellerData.length > 0 && (
              <div className='frr-inv-aud-labeler-table'>
                <TableGridWithFeatures
                  data-testid='labeler-stc-table'
                  rowSelection='single'
                  rowMultiSelectWithClick={false}
                  fullScreenView={props.labelerFullScreen}
                  handleFullScreenViewClick={handleFullScreenLabeler}
                  gridHeight='55vh'
                  rowData={labellerData}
                  columnDefs={labelerTableHead}
                  exportFile
                  animateRows
                  sideBar={false}
                  gridCall={onGridReadyLabeler}
                  fileName={`${props.id}-Labeler`}
                  singleClickEdit
                  navigateToNextCell={navigateToNextCell}
                  tabToNextCell={tabToNextCell}
                  enterMovesDown
                  suppressCellFocus
                  onCellFocused={onCellFocused}
                  onSelect={(e) => onRowSelect('labeler', e.data)}
                  info={{ firstInfo }}

                />
              </div>
            )}
          <div className='FRR-custom-table'>
            <div className='tab-header display-inline-flex mt-sm-4'>
              {selectedVal && selectedVal == 'Name' ? (
                <div className='selectedByName'>
                  <label
                    htmlFor='standard-reason-code-name'
                    className='visually-hidden'
                  >
                    standard reason code
                  </label>
                  <TextField
                    id='standard-reason-code-name'
                    placeholder='Search...'
                    variant='outlined'
                    className='searchInput'
                    value={searchValue}
                    inputProps={{
                      maxLength: 30,
                    }}
                    onChange={(e) => handleChangeSearchVal(e.target.value)}
                  />

                  <div className='float-right btn-wrapper pt-1'>
                    <div className='dif'>
                      <div tabIndex={0}>
                        <Button
                          id='name-filter-btn-id'
                          title=' Search '
                          className='btn btn-success btn-search ml-1'
                          onClick={() => {
                            handleSearchName('onClick');
                          }}
                        >
                          <SVGComponent iconName='Icon-search' />
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='clearfix' />
              )}

              <div className='float-right btn-wrapper pt-1'>
                {props.addDetailButtonname ? (
                  <div>
                    <Button
                      id='name-filter-btn-id'
                      title='Search'
                      className='btn btn-success btn-search ml-1 float-right search-comp'
                      onClick={handleViewButton}
                    >
                      <SVGComponent iconName='Icon-outline-add-circle' /> {'  '}{' '}
                      {props.addDetailButtonname}
                    </Button>
                  </div>
                ) : props.viewDetailButtonName ? (
                  <div>
                    <Button
                      id='name-filter-btn-id'
                      title='Search'
                      className='btn btn-success btn-search ml-1 float-right'
                      onClick={handleViewButton}
                    >
                      <SVGComponent
                        iconName={
                          props?.iconName === 'search'
                            ? 'Icon-search'
                            : 'Icon-view'
                        }
                      />{' '}
                      {props.viewDetailButtonName}
                    </Button>
                  </div>
                ) : (
                  <div className='display-inline-flex'>
                    <Button
                      id='name-filter-btn-id'
                      title={props.runNowButtonName}
                      className='btn btn-success btn-search ml-1 float-right'
                      onClick={() => {
                        handleViewButton('runNow');
                      }}
                    >
                      <SVGComponent iconName={'Icon-run-now'} /> {'  '}{' '}
                      {props.runNowButtonName}
                    </Button>

                    <Button
                      id='name-filter-btn-id'
                      title={props.runLaterButtonName}
                      className='btn btn-success btn-search float-right'
                      onClick={() => {
                        handleViewButton('runLater');
                      }}
                    >
                      <SVGComponent iconName={'Icon-run-later'} /> {'  '}{' '}
                      {props.runLaterButtonName}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <div>
              <DisplayErrorMessages
                errorMessages={
                  //  eslint-disable-next-line react/destructuring-assignment
                  props.errorMsgFromSearchType?.length > 0
                    ? _.filter(
                        // eslint-disable-next-line react/destructuring-assignment
                        props.errorMsgFromSearchType,
                        // eslint-disable-next-line eqeqeq
                        (l) => l.field == 'searchByNameError' && l.message
                      ).map((val) => val.message)
                    : []
                }
              />
            </div>
            <div>
              <DisplayErrorMessages
                errorMessages={
                  // eslint-disable-next-line react/destructuring-assignment
                  props.errorMsgFromSearchType?.length > 0
                    ? _.filter(
                        // eslint-disable-next-line react/destructuring-assignment
                        props.errorMsgFromSearchType,
                        // eslint-disable-next-line eqeqeq
                        (l) => l.field == 'resultNotFound' && l.message
                      ).map((val) => val.message)
                    : []
                }
              />
            </div>
          </div>
          <div className='ndcsTableSection FRR-custom-table'>
            <div className='ndcTable ndcTableLeft'>
              {/* eslint-disable-next-line eqeqeq */}
              {selectedVal && selectedVal == 'NDC' && (
                <div className=' selectedByNDCs'>
                  <label className='ndcLabel' htmlFor='standard-reason-code'>
                    Enter NDC to be Added{' '}
                    <span className='mandatory'>{' *'}</span>
                  </label>
                  <TextField
                    label='Enter NDC to be Added'
                    id='standard-reason-code-ndc'
                    value={ndcVal}
                    required
                    placeholder='XXXXX-XXXX-XX'
                    variant='outlined'
                    className='searchInput mb-2 frr-display-hidden-label'
                    onBlur={(e) => handleBlur('onBlur', e)}
                    inputProps={{
                      maxLength: 13,

                      id: 'standard-reason-code-ndc',
                    }}
                    onChange={(e) => {
                      // eslint-disable-next-line eqeqeq
                      if (!(e.target.value && e.target.value == '-')) {
                        onSearchByNDCs('onEnter', e);
                      }
                    }}
                    onKeyDown={(e) => {
                      // eslint-disable-next-line eqeqeq
                      if (!(e.target.value && e.target.value == '-')) {
                        onSearchByNDCs('onEnter', e);
                      }
                    }}
                  />
                  <DisplayErrorMessages
                    errorMessages={
                      // eslint-disable-next-line react/destructuring-assignment
                      props.errorMsgFromSearchType?.length > 0
                        ? _.filter(
                            // eslint-disable-next-line react/destructuring-assignment
                            props.errorMsgFromSearchType,
                            (l) =>
                              // eslint-disable-next-line eqeqeq
                              (l.field == 'ndcTextBox' ||
                                // eslint-disable-next-line eqeqeq
                                l.field == 'resultNotFoundNDCText') &&
                              l.message
                          ).map((val) => val.message)
                        : []
                    }
                  />
                </div>
              )}
              {/* eslint-disable-next-line eqeqeq */}
              {selectedVal && selectedVal != 'NDC' && (
                <>
                  <TableGridWithFeatures
                    ref={gridRefLeft}
                    data-testid='ndcleft-stc-table'
                    rowSelection='multiple'
                    frameworkComponents={{
                      TextBoxRender: (cellInfo) => {
                        const name = cellInfo?.value;

                        if (name && name.length > 20) {
                          return (
                            <OverlayTrigger
                              placement='bottom'
                              overlay={
                                <Tooltip id='labeler-tooltip'>{name}</Tooltip>
                              }
                            >
                              <div>{name}</div>
                            </OverlayTrigger>
                          );
                        }
                        return <div>{name}</div>;
                      },
                    }}
                    rowMultiSelectWithClick={false}
                    // eslint-disable-next-line react/destructuring-assignment
                    fullScreenView={props.ndcLeftFullScreen}
                    handleFullScreenViewClick={handleFullScreenNdcLeft}
                    gridHeight='50vh'
                    rowData={ndcLeftData}
                    columnDefs={NDCTableHead}
                    exportFile
                    animateRows
                    sideBar={false}
                    // eslint-disable-next-line react/destructuring-assignment
                    fileName={`${props.id}-NDC`}
                    singleClickEdit
                    gridCall={onGridReadyLeftNDC}
                    navigateToNextCell={navigateToNextCell}
                    tabToNextCell={tabToNextCell}
                    onSelectionChanged={onSelectionChangedLeft}
                    enterMovesDown
                    suppressCellFocus
                    onCellFocused={onCellFocused}
                    onSelect={(e) => onRowSelect('NDCLeft', e.data)}
                    info={{ firstInfo }}

                  />
                </>
              )}
            </div>

            <div className='ndcTableBtn2 RightArrow'>
              <Button
                id='ndcTableBtnId'
                className='btn-primary'
                onClick={() => actionNDCsMove('leftToRight', 'ndcLeftData')}
                tabIndex={0}
                aria-label='RightArrow'
              >
                <i className='fa fa-light fa-caret-right' aria-hidden='true' />
                <span className='hide-elm'>Right Arrow</span>
              </Button>
              {selectedVal !== 'NDC' && (
                <Button
                  id='ndcTableBtnIdALTR AllLeftArrow'
                  className='btn-primary'
                  onClick={() => actionNDCsMove('AllLeftToRight', null)}
                  tabIndex={0}
                  aria-label='AllLeftArrow'
                >
                  <i className='fa fa-light fa-forward' aria-hidden='true' />
                  <span className='hide-elm'>Left Arrow</span>
                </Button>
              )}
              {selectedVal !== 'NDC' && (
                <Button
                  id='ndcTableBtnIdARTL AllRightArrow'
                  className='btn-primary'
                  onClick={() => actionNDCsMove('AllRightToLeft', null)}
                  tabIndex={0}
                  aria-label='AllRightArrow'
                >
                  <i className='fa fa-light fa-backward' aria-hidden='true' />
                  <span className='hide-elm'>Right Arrow</span>
                </Button>
              )}
              <Button
                id='ndcTableBtnIdRTL LeftArrow'
                className='btn-primary'
                onClick={() => actionNDCsMove('rightToLeft', 'ndcRightData')}
                tabIndex={0}
                aria-label='LeftArrow'
              >
                <i className='fa fa-light fa-caret-left' aria-hidden='true' />
                <span className='hide-elm'>Left Arrow</span>
              </Button>
            </div>
            <div className='ndcTable ndcTableRight'>
              <TableGridWithFeatures
                ref={gridRefRight}
                data-testid='ndcright-stc-table'
                rowSelection='multiple'
                rowMultiSelectWithClick={false}
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenNdcRight}
                gridHeight='50vh'
                rowData={ndcRightData}
                columnDefs={NDCTableHead}
                gridCall={onGridReadyRightNDC}
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 20) {
                      return (
                        <OverlayTrigger
                          placement='bottom'
                          overlay={
                            <Tooltip id='labeler-tooltip'>{name}</Tooltip>
                          }
                        >
                          <div>{name}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
                exportFile
                animateRows
                sideBar={false}
                // eslint-disable-next-line react/destructuring-assignment
                fileName={`${props.id}-NDC`}
                singleClickEdit
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                onSelectionChanged={onSelectionChangedRight}
                suppressCellFocus
                onCellFocused={onCellFocused}
                onSelect={(e) => onRowSelect('NDCRight', e.data)}
                info={{ firstInfo }}

              />
            </div>
          </div>
        </>
      )}
      {/* eslint-disable-next-line ,react/destructuring-assignment */}
      {(props.labelerFullScreen ||
        // eslint-disable-next-line react/destructuring-assignment
        props.ndcLeftFullScreen ||
        // eslint-disable-next-line react/destructuring-assignment
        props.ndcRightFullScreen) && (
        <>
          {/* eslint-disable-next-line react/destructuring-assignment */}
          {props.labelerFullScreen && (
            <TableGridWithFeatures
              data-testid='labeler-stc-table'
              rowSelection='single'
              rowMultiSelectWithClick={false}
              // eslint-disable-next-line react/destructuring-assignment
              fullScreenView={props.labelerFullScreen}
              handleFullScreenViewClick={handleFullScreenLabeler}
              // eslint-disable-next-line camelcase
              gridHeight={viewPortHeight_355}
              rowData={labellerData}
              columnDefs={labelerTableHead}
              exportFile
              animateRows
              sideBar={false}
              gridCall={onGridReadyLabeler}
              // eslint-disable-next-line react/destructuring-assignment
              fileName={`${props.id}-Labeler`}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              onSelect={(e) => onRowSelect('labeler', e.data)}
              info={{ firstInfo }}

            />
          )}
          {/* eslint-disable-next-line react/destructuring-assignment */}
          {props.ndcLeftFullScreen && (
            <TableGridWithFeatures
              ref={gridRefLeft}
              data-testid='ndcleft-stc-table'
              rowSelection='multiple'
              rowMultiSelectWithClick={false}
              // eslint-disable-next-line react/destructuring-assignment
              fullScreenView={props.ndcLeftFullScreen}
              handleFullScreenViewClick={handleFullScreenNdcLeft}
              // eslint-disable-next-line camelcase
              gridHeight={viewPortHeight_355}
              rowData={ndcLeftData}
              columnDefs={NDCTableHead}
              exportFile
              animateRows
              sideBar={false}
              gridCall={onGridReadyLeftNDC}
              // eslint-disable-next-line react/destructuring-assignment
              fileName={`${props.id}-NDC`}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              onSelectionChanged={onSelectionChangedLeft}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              onSelect={(e) => onRowSelect('NDCLeft', e.data)}
              info={{ firstInfo }}

            />
          )}

          {/* eslint-disable-next-line react/destructuring-assignment */}
          {props.ndcRightFullScreen && (
            <TableGridWithFeatures
              ref={gridRefRight}
              data-testid='ndcright-stc-table'
              rowSelection='multiple'
              rowMultiSelectWithClick={false}
              // eslint-disable-next-line react/destructuring-assignment
              fullScreenView={props.ndcRightFullScreen}
              handleFullScreenViewClick={handleFullScreenNdcRight}
              // eslint-disable-next-line camelcase
              gridHeight={viewPortHeight_355}
              rowData={ndcRightData}
              columnDefs={NDCTableHead}
              exportFile
              animateRows
              sideBar={false}
              // eslint-disable-next-line react/destructuring-assignment
              fileName={`${props.id}-NDC`}
              gridCall={onGridReadyRightNDC}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              onSelectionChanged={onSelectionChangedRight}
              suppressCellFocus
              onCellFocused={onCellFocused}
              onSelect={(e) => onRowSelect('NDCRight', e.data)}
              info={{ firstInfo }}

            />
          )}
        </>
      )}
    </div>
  );
};

export default SearchTypeComponent;
